
import { makeStyles, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import { IconButton } from "@mui/material";


const useStyles = makeStyles((theme) => ({
    root: {
        height: 70,
        width: '100%',
        background: '#85287e',
        borderRadius: 5,
        transition: '0.3s',
        overflow:'scroll',

        [theme.breakpoints.down('xs')]: {
            width: '100%',
        },
        '&:hover': {
            boxShadow: '3px 3px 3px #67348d'
        }
    },
}))

type cardServicesProps = {
    // imageView: string,
    // imageDowload: string,
    nomeOpcao: string;
    link: string;
    url?: string;
}
export default function ListaOpcoes({ nomeOpcao, link, url }: cardServicesProps) {
    const classes = useStyles()

    return (
        <div style={{ display: 'flex', gap: 2, marginTop: 15, }}>

            {url &&
                <IconButton onClick={() => window.open(url ?? link, "_blank", "noopener,noreferrer")}>
                    <img src='/img/icones/downloadicon.svg' alt="downloadicon" />
                </IconButton>
            }

            <CardActionArea className={classes.root} >
                <Link style={{ textDecoration: 'none' }} to={link}>
                    <CardContent style={{ padding: 5 }}>
                        <Typography variant="subtitle1" style={{ lineHeight: 1, fontSize: 15, color: '#fff', paddingLeft: 20 }}>
                            {nomeOpcao}
                        </Typography>
                    </CardContent>
                </Link>
            </CardActionArea>
        </div>
    )
}